// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MaterialsPage_wrapper__GGyLz","cardsWrapper":"MaterialsPage_cardsWrapper__2MVRL"};